<script>
	import InfoContent from './../learn/InfoContent.svelte';
    import InfoPageTemplate from './InfoPageTemplate.svelte';
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';

    onMount(() => {
        window.scrollTo(0, 0);
    });
</script>

<style>
    .video-grid {
        max-width: 1400px;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        row-gap: var(--spacingXLarge);
        padding: var(--spacingLarge);
    }

    .video-grid :global.video-wrap {
        max-width: 300px;
        max-height: 195px;
    }

    .video-grid :global.info-wrap {
        max-width: 300px;
    }

    .footnote {
        line-height: 1.5;
    }

</style>

<InfoPageTemplate>
    <div slot="header-section">
        <h1>{$_('learn.infopage_3.title')}</h1>
    </div>
    <div class="video-grid" slot="content-section">
        <InfoContent isVideo bg_img="/img/video_thumbnails/hoftextensorer_1.jpg" source="video/Myometri_hoftextensorer_1.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.hip_ext_1').toLowerCase()}">{$_('calculator.muscles.hip_ext_1')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/hoftextensorer_2.jpg" source="video/Myometri_hoftextensorer_2.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.hip_ext_2').toLowerCase()}">{$_('calculator.muscles.hip_ext_2')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/hoftflexorer_1.jpg" source="video/Myometri_hoftflexorer_1.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.hip_flex_1').toLowerCase()}">{$_('calculator.muscles.hip_flex_1')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/hoftflexorer_2.jpg" source="video/Myometri_hoftflexorer_2.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.hip_flex_2').toLowerCase()}">{$_('calculator.muscles.hip_flex_2')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/hoftabduktorer.jpg" source="video/Myometri_hoftabduktorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.hip_abd').toLowerCase()}">{$_('calculator.muscles.hip_abd')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/hoftadduktorer.jpg" source="video/Myometri_hoftadduktorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.hip_add').toLowerCase()}">{$_('calculator.muscles.hip_add')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/knaextensorer.jpg" source="video/Myometri_knaextensorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.kn_ext').toLowerCase()}">{$_('calculator.muscles.kn_ext')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/knaflexorer.jpg" source="video/Myometri_knaflexorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.kn_flex').toLowerCase()}">{$_('calculator.muscles.kn_flex')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/fot_dorsalflexorer.jpg" source="video/Myometri_fot_dorsalflexorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.f_dors').toLowerCase()}">{$_('calculator.muscles.f_dors')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/fot_plantarflexorer.jpg" source="video/Myometri_fot_plantarflexorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.f_plant').toLowerCase()}">{$_('calculator.muscles.f_plant')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/skulderabduktorer.jpg" source="video/Myometri_skulderabduktorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.sh_abd').toLowerCase()}">{$_('calculator.muscles.sh_abd')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/armbagsextensorer.jpg" source="video/Myometri_armbagsextensorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.eb_ext').toLowerCase()}">{$_('calculator.muscles.eb_ext')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/armbagsflexorer.jpg" source="video/Myometri_armbagsflexorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.eb_flex').toLowerCase()}">{$_('calculator.muscles.eb_flex')}</InfoContent>
        <InfoContent isVideo bg_img="/img/video_thumbnails/hand_dorsalflexorer.jpg" source="video/Myometri_hand_dorsalflexorer.mp4" caption="{$_('learn.infopage_3.video_description')}: {$_('calculator.muscles.h_dors').toLowerCase()}">{$_('calculator.muscles.h_dors')}</InfoContent>
    </div>
    <div class="footnote" slot="footer-section">
        {$_('learn.infopage_3.footer')}
    </div>
</InfoPageTemplate>